import type { TableFields } from './types'

export const tableMockData: TableFields = {
  heading: 'Choose your box size',
  columns: [{ header: 'Box Size' }, { header: 'Great for' }, { header: 'First box price' }],
  rows: [
    {
      row_id: 'one',
      cells: [
        { value: '1 person box', is_bold: true },
        { value: 'Single person households' },
        { value: 'Get 5 meals for the week for just £17.50' },
      ],
    },
    {
      row_id: 'two',
      cells: [
        { value: '2 person box', is_bold: true },
        { value: '2 adults (or 1 adult + leftovers)' },
        { value: 'Get 5 meals for the week for just £22.35' },
      ],
    },
    {
      row_id: 'three',
      cells: [
        { value: '3 person box', is_bold: true },
        { value: '3 adults (or 2 adults + leftovers)' },
        { value: 'Get 5 meals for the week for just £30.00' },
      ],
    },
    {
      row_id: 'four',
      cells: [
        { value: '4 person box', is_bold: true },
        { value: '4 adults (or 2-3 adults + leftovers)' },
        { value: 'Get 5 meals for the week for just £30.88' },
      ],
    },
    {
      row_id: 'five',
      cells: [
        { value: '5 person box', is_bold: true },
        { value: '5 adults (or 3-4 adults + leftovers)' },
        { value: 'Get 3 meals for the week for just £28.38' },
      ],
    },
  ],
}
